/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SpamInputs */

const cs_enum_spam = /** @type {(inputs: Enum_SpamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam`)
};

const en_enum_spam = /** @type {(inputs: Enum_SpamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam`)
};

/**
* | output |
* | --- |
* | "Spam" |
*
* @param {Enum_SpamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_spam = /** @type {((inputs?: Enum_SpamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SpamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_spam(inputs)
	return cs_enum_spam(inputs)
});